import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const systemAdminAPI = createApi({
    reducerPath: "systemAdminAPI",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["systemAdmin"],
    endpoints: (builder) => ({
        getSystemAdminData: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/system-access/sub-admin/list?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["systemAdmin"],
        }),

        saveSystemAdmin: builder.mutation({
            query: (payload) => ({
                url: `/system-access/sub-admin/create`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["systemAdmin"],
        }),

        updateSystemAdmin: builder.mutation({
            query: ({ id, data }) => ({
                url: `/system-access/sub-admin/update/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["systemAdmin"],
        }),

        deleteSystemAdmin: builder.mutation({
            query: (id) => ({
                url: `/system-access/sub-admin/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["systemAdmin"],
        }),

        getRolesList: builder.query({
            query: () => `/system-access/role/list`,
            providesTags: ["systemAdmin"],
        }),
    }),
});

export const {
    useGetSystemAdminDataQuery,
    useSaveSystemAdminMutation,
    useUpdateSystemAdminMutation,
    useDeleteSystemAdminMutation,
    useGetRolesListQuery
} = systemAdminAPI;
